import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyA7bV6OD-Z1gQjqmUwO4s9OIALsyRQ675Q",
  authDomain: "jainsamagra-ec5cc.firebaseapp.com",
  databaseURL: "https://jainsamagra-ec5cc-default-rtdb.firebaseio.com",
  projectId: "jainsamagra-ec5cc",
  storageBucket: "jainsamagra-ec5cc.firebasestorage.app",
  messagingSenderId: "807390743324",
  appId: "1:807390743324:web:946396d993ef4e3662c8d9",
  measurementId: "G-RMTY3PSY7L"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export { db };